import React from 'react'
import { connect } from 'react-redux'
import { getInvestments } from 'services/user'
import Navigation from 'support/navigation'
import { getGroups } from 'services/challenge_steps'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
// import ConfirmEvaluatorDeleteIdeaModal from './dialogs/ConfirmEvaluatorDeleteContainer'
import ConfirmSubmitModalIdeaAddBulkSME from './dialogs/ConfirmSubmitModalIdeaAddBulkSME'
import ConfirmEvaluatorDeleteChallengeModal from './dialogs/ConfirmEvaluatorRatingDeleteContainer'
import ConfirmEvaluatorDeleteByIdeaListModal from './dialogs/ConfirmEvaluatorDeleteByIdeaListContainer'
import View from './View'
import { getInnovateChallengeFilterList, getInnovateChallengeActiveTypes, getInnovateChallengeAllList, getInnovateChallengeListForRemoveEvaluator, getInnovateIdeaListFromChallengeForRemoveEvaluator } from 'services/innovate/challenge'
import { getInnovateChallengeTaggedIdeaList, deleteAssignedEvaluatorIntoIdeaDetail, deleteAllAssignedEvaluatorIntoIdea ,deleteEvaluatorFromChallengesAllIdea} from 'services/innovate/idea'
import i18n from 'support/i18n'

const mapStateToProps = state => {
  return {
    ideas: state.data.user.investments.ideas,
    userEmail: state.data.user.userEmail,
    isAdmin: state.data.user.admin,
    // listInnovateChallenge:state.data.InnovateChallenge.listInnovateChallenge,
    listInnovateChallenge: state.data.InnovateChallenge.filterListInnovateChallenge,
    innovateCategoryTypes: state.data.InnovateChallenge.innovateCategoryTypes,
    listCommunitesChallenge: state.data.InnovateChallenge.listInnovateCommunitesChallenge,
    InnovateGetChallengeTaggedIdeaListIsLoading: state.data.InnovateIdea.innovateGetChallengeTaggedIdeaListIsLoading,
    postInnovateIdeaAddBySMEGroupsIsLoading: state.data.InnovateIdea.postInnovateIdeaAddBySMEGroupsIsLoading,
    InnovateGetChallengeTaggedIdeaList: state.data.InnovateIdea.innovateGetChallengeTaggedIdeaList,


    domainLoaded: state.data.domain.dataLoaded,
    getInnovateIdeaListFromChallenge: state.data.InnovateChallenge.getIdeaListFromChallengeRemoveEvaluator,
    postReponseDataForSpecificIdeaList: state.data.InnovateChallenge.postInnovateSpecificIdeaListChallengeRemoveEvaluator,

    listInnovateChallengeForEvalutor: state.data.InnovateChallenge.filterListInnovateChallenge,
    challengesListIsLoading: state.data.InnovateChallenge.filterListInnovateChallengeLoading,

    postAfterRemoveEvalutor: state.data.InnovateChallenge.postInnovateChallengeRemoveEvaluator,
    postAfterRemoveEvalutorIsLoading: state.data.InnovateChallenge.postInnovateChallengeRemoveEvaluatorIsLoading,
    postAfterIdeaListRemoveEvalutorIsLoading: state.data.InnovateChallenge.postInnovateSpecificIdeaListChallengeRemoveEvaluatorIsLoading,
    getListIdeaListRemoveEvalutorIsLoading: state.data.InnovateChallenge.getIdeaListFromChallengeRemoveEvaluatorIsLoading,

  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCommunitesAsGroup: () => dispatch(getGroups()),

    getInnovateChallengeAllListFn: () => {
      dispatch(getInnovateChallengeAllList())
    },

    getInnovateChallengeFilterListFn: (challengeStatus, offset, limit, enableIsHackathon) => {
      dispatch(getInnovateChallengeFilterList({ challengeStatus, offset, limit, enableIsHackathon }))
    },

    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },

    getInnovateChallengeTaggedIdeaListFn: (challengeKey) => {
      dispatch(getInnovateChallengeTaggedIdeaList(challengeKey))
    },

    deleteAssignedEvaluatorIntoIdeaFn: (deleteEvaluatorlistParams, onSuccessCallback, onFailureCallback) => {
      const onSuccess = () => {
        // Refresh the tagged idea list for the current challenge
        if (deleteEvaluatorlistParams?.challengeKey) {
          dispatch(getInnovateChallengeTaggedIdeaList(deleteEvaluatorlistParams.challengeKey))
        }
        if (onSuccessCallback) onSuccessCallback()
      }
      const onFailure = (error) => {
        if (onFailureCallback) onFailureCallback(error)
      }
      dispatch(deleteAssignedEvaluatorIntoIdeaDetail(deleteEvaluatorlistParams, onSuccess, onFailure))
    },

    //all evaluator delete fn
    deleteAllAssignedEvaluatorIntoIdeaFn: (deleteEvaluatorlistParams, onSuccessCallback, onFailureCallback) => {
      console.log("deleteEvaluatorlistParams==> ALL Assign ", deleteEvaluatorlistParams)
      const onSuccess = () => {
        // Refresh the tagged idea list for the current challenge
        if (deleteEvaluatorlistParams?.challengeKey) {
          dispatch(getInnovateChallengeTaggedIdeaList(deleteEvaluatorlistParams.challengeKey))
        }
        if (onSuccessCallback) onSuccessCallback()
      }
      const onFailure = (error) => {
        if (onFailureCallback) onFailureCallback(error)
      }
      dispatch(deleteAllAssignedEvaluatorIntoIdea(deleteEvaluatorlistParams, onSuccess, onFailure))
    },

    //bulk auto assign Evaluator
    postInnovateIdeaAddBySMEGroupsFn: (ideaBulkSMEAddParams, otherParams) => {
      showPopupDialog(<ConfirmSubmitModalIdeaAddBulkSME ideaBulkSMEAddParams={ideaBulkSMEAddParams} />, dispatch)
    },

    deleteAssignedEvaluatorIntoChallengeFn: (EvaluatorlistParams) => {
      showPopupDialog(<ConfirmEvaluatorDeleteChallengeModal EvaluatorlistParams={EvaluatorlistParams} />, dispatch)
    },
    onDeteleSpecificIdeaListFromChallengeFn: (EvaluatorlistParamsByIdea) => {
      showPopupDialog(<ConfirmEvaluatorDeleteByIdeaListModal EvaluatorlistParamsByIdea={EvaluatorlistParamsByIdea} />, dispatch)
    },
    getInnovateChallengeAllListForRemoveEvaluatorFn: () => {
      dispatch(getInnovateChallengeListForRemoveEvaluator())
    },
    getIdeaListFromChallengeFn: (TaggedIdeaParams) => {
      dispatch(getInnovateIdeaListFromChallengeForRemoveEvaluator(TaggedIdeaParams))
    },

    
      deleteEvaluatorFromChallengesAllIdeaFn : (selectedParams, onSuccessCallback, onFailureCallback)=>{
      // console.log("deleteEvaluatorFromChallengesAllIdeaFn==> ",selectedParams )
      const onSuccess = () => {
        // Refresh the tagged idea list for the current challenge
        if (selectedParams?.challengeKey) {
          dispatch(getInnovateChallengeTaggedIdeaList(selectedParams.challengeKey))
        }
        if (onSuccessCallback) onSuccessCallback()
      }
      const onFailure = (error) => {
        if (onFailureCallback) onFailureCallback(error)
      }
      dispatch(deleteEvaluatorFromChallengesAllIdea(selectedParams, onSuccess, onFailure))
    },

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
